import { DIV, SPAN, A } from 'sdi/components/elements';
import tr from 'sdi/locale';
import { getCurrentOsmUserName } from '../queries/qa';
import { Link } from './header';

export const renderHeaderSelect = (links: Link[], title: string) => {
    const tail = links.map(l =>
        DIV(
            { className: `header-select-item` },
            A(
                {
                    className: 'tail-name disabled', // TEMP
                    href: l.url,
                },
                l.name
            )
        )
    );

    const head = DIV(
        { className: 'selected head' },
        SPAN({ className: 'head-label' }, title)
    );

    return DIV(
        {
            className: 'select__wrapper connexion-select select-2',
            onClick: e => e.currentTarget.classList.toggle('active'),
        },
        DIV({ className: 'select' }, head, DIV({ className: 'tail' }, ...tail))
    );
};

export const renderConnexionSelect = () => {
    const connexions: Link[] = [
        {
            // url: `${getApiUrl(
            //     'geodata/accounts/openstreetmap/login/?process=login'
            // )}`, // TEMP
            url: '',
            name: 'Connexion OSM',
        },
        {
            //url: `${getApiUrl('geodata/accounts/openstreetmap/change-user/')}`,  // TEMP
            url: '',
            name: `Changer d'utilisateur`,
        },
    ];
    return renderHeaderSelect(
        connexions,
        `${getCurrentOsmUserName().getOrElse(`${tr.qa('noOSMConnection')}`)}`
    );
};
